var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      width: "600",
      scrollable: "",
      title: "Edit Field",
      dialog: _vm.show,
    },
    on: { close: _vm.closeDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            bindData: _vm.ClaimFieldData.custom_field_label,
                            label: "Label",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.ClaimFieldData.custom_field_label = valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _vm._v(" Form Builder Field Type: "),
                        _c("v-select", {
                          attrs: {
                            items: _vm.allFieldType,
                            "item-text": "view_fields",
                            "item-value": "value_field",
                            filled: "",
                            rules: _vm.$GetRules("_Require_Rules", [null]),
                            "single-line": "",
                            "hide-details": "",
                            dense: "",
                            label: "Field Type",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "no-data",
                              fn: function () {
                                return [_c("noContent")]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.ClaimFieldData.formbuilder_uuid,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.ClaimFieldData,
                                "formbuilder_uuid",
                                $$v
                              )
                            },
                            expression: "ClaimFieldData.formbuilder_uuid",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            bindData: _vm.ClaimFieldData.custom_field_name,
                            label: "Name",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.ClaimFieldData.custom_field_name = valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _vm._v(" Description: "),
                        _c("v-textarea", {
                          attrs: {
                            rows: "5",
                            "no-resize": "",
                            maxlength: "500",
                            dense: "",
                            counter: "500",
                            "single-line": "",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            "hide-details": "",
                            filled: "",
                          },
                          model: {
                            value: _vm.ClaimFieldData.custom_field_description,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.ClaimFieldData,
                                "custom_field_description",
                                $$v
                              )
                            },
                            expression:
                              "ClaimFieldData.custom_field_description",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _vm._v(" Data Type: "),
                        _c("v-select", {
                          attrs: {
                            items: _vm.allDataType,
                            filled: "",
                            rules: _vm.$GetRules("_Require_Rules", [null]),
                            "single-line": "",
                            "hide-details": "",
                            dense: "",
                            label: "Data Type",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "no-data",
                              fn: function () {
                                return [_c("noContent")]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.ClaimFieldData.custom_field_data_type,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.ClaimFieldData,
                                "custom_field_data_type",
                                $$v
                              )
                            },
                            expression: "ClaimFieldData.custom_field_data_type",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _vm._v(" Data Length: "),
                        _c("v-text-field", {
                          attrs: {
                            label: "Data Length",
                            type: "number",
                            filled: "",
                            rules: _vm.$GetRules(["_Number_negative"], [null]),
                            "single-line": "",
                            placeholder: "Data Length",
                            "hide-details": "",
                            dense: "",
                          },
                          model: {
                            value: _vm.ClaimFieldData.custom_field_data_length,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.ClaimFieldData,
                                "custom_field_data_length",
                                $$v
                              )
                            },
                            expression:
                              "ClaimFieldData.custom_field_data_length",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _vm._v(" Date Decimal: "),
                        _c("v-text-field", {
                          attrs: {
                            label: "Date Decimal",
                            type: "number",
                            filled: "",
                            "single-line": "",
                            rules: _vm.$GetRules(["_Number_negative"], [null]),
                            placeholder: "Date Decimal",
                            "hide-details": "",
                            dense: "",
                          },
                          model: {
                            value: _vm.ClaimFieldData.custom_field_data_decimal,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.ClaimFieldData,
                                "custom_field_data_decimal",
                                $$v
                              )
                            },
                            expression:
                              "ClaimFieldData.custom_field_data_decimal",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _vm._v(" Date Format: "),
                        _c("v-text-field", {
                          attrs: {
                            label: "Date Format",
                            filled: "",
                            "single-line": "",
                            placeholder: "Date Format",
                            "hide-details": "",
                            dense: "",
                          },
                          model: {
                            value: _vm.ClaimFieldData.custom_field_data_format,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.ClaimFieldData,
                                "custom_field_data_format",
                                $$v
                              )
                            },
                            expression:
                              "ClaimFieldData.custom_field_data_format",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _vm._v(" Related Table: "),
                        _c("v-select", {
                          attrs: {
                            items: _vm.allTable,
                            "item-text": "view_fields",
                            "item-value": "value_field",
                            "hide-details": "",
                            filled: "",
                            "single-line": "",
                            dense: "",
                            label: "Related Table",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "no-data",
                              fn: function () {
                                return [_c("noContent")]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value:
                              _vm.ClaimFieldData.custom_field_relate_to_table,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.ClaimFieldData,
                                "custom_field_relate_to_table",
                                $$v
                              )
                            },
                            expression:
                              "ClaimFieldData.custom_field_relate_to_table",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _vm._v(" Related Field: "),
                        _c("v-select", {
                          attrs: {
                            items: _vm.allField,
                            "item-text": "view_fields",
                            "item-value": "value_field",
                            filled: "",
                            "single-line": "",
                            "hide-details": "",
                            dense: "",
                            label: "Related Field",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "no-data",
                              fn: function () {
                                return [_c("noContent")]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value:
                              _vm.ClaimFieldData.custom_field_relate_to_field,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.ClaimFieldData,
                                "custom_field_relate_to_field",
                                $$v
                              )
                            },
                            expression:
                              "ClaimFieldData.custom_field_relate_to_field",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("v-checkbox", {
                          attrs: { color: "primary", label: "Required" },
                          model: {
                            value: _vm.ClaimFieldData.is_required,
                            callback: function ($$v) {
                              _vm.$set(_vm.ClaimFieldData, "is_required", $$v)
                            },
                            expression: "ClaimFieldData.is_required",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("v-checkbox", {
                          attrs: { color: "primary", label: "Unique" },
                          model: {
                            value: _vm.ClaimFieldData.is_unique,
                            callback: function ($$v) {
                              _vm.$set(_vm.ClaimFieldData, "is_unique", $$v)
                            },
                            expression: "ClaimFieldData.is_unique",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: { saveBtn: "", cancelBtn: "" },
              on: { save: _vm.onEdit, cancel: _vm.closeDialog },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }